module.exports = __webpack_public_path__ + "img/laundry.d5e42c13.svg";